import React from 'react';
import type { Organism } from '@verndale/core';
import globModules from './glob-modules';
import { renderElement } from './helpers/react-18-shim';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reactModule = (Component: any, nodeList: NodeListOf<HTMLElement>) => {
  return nodeList.forEach(node => {
    renderElement(<Component {...node.dataset} />, node);
  });
};

const modules: Organism[] = [
  {
    name: 'consentModal',
    loader: () => import('./modules/consentModal')
  },
  {
    name: 'orbsBackground',
    loader: () => import('./modules/orbsBackground')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'mockApi',
    styles: () => import('../scss/modules/mock-api.scss'),
    loader: () => import('./modules/mockApi'),
    render: reactModule
  },
  {
    name: 'leadershipNavigationCards',
    styles: () => import('../scss/modules/leadership-navigation-cards.scss')
  },
  {
    name: 'veeva',
    styles: () => import('../scss/modules/veeva.scss')
  },
  {
    name: 'interactiveAccordionModule',
    styles: () => import('../scss/modules/interactive-accordion-module.scss'),
    loader: () => import('./modules/interactiveAccordionModule')
  },
  {
    name: 'leadershipListing',
    loader: () => import('./modules/leadershipListing'),
    styles: () => import('../scss/modules/leadership-listing.scss')
  },
  {
    name: 'sharePage',
    loader: () => import('./modules/sharePage'),
    styles: () => import('../scss/modules/share-page.scss')
  },
  {
    name: 'contactCardsContainer',
    styles: () => import('../scss/modules/contact-cards-container.scss')
  },
  {
    name: 'featuredLeadersCarousel',
    loader: () => import('./modules/featuredLeadersCarousel'),
    styles: () => import('../scss/modules/featured-leaders-carousel.scss')
  },
  {
    name: 'therapyAreasListing',
    styles: () => import('../scss/modules/therapy-areas-listing.scss')
  },
  {
    name: 'authorCardsContainerDefault',
    styles: () => import('../scss/modules/author-cards-container-default.scss')
  },
  {
    name: 'relatedArticlesCarousel',
    loader: () => import('./modules/relatedArticlesCarousel'),
    styles: () => import('../scss/modules/related-articles-carousel.scss')
  },
  {
    name: 'tagsContainer',
    styles: () => import('../scss/modules/tags-container.scss')
  },
  {
    name: 'factsheetDetailMasthead',
    styles: () => import('../scss/modules/factsheet-detail-masthead.scss')
  },
  {
    name: 'blockquote',
    styles: () => import('../scss/modules/blockquote.scss')
  },
  {
    name: 'ctaModule',
    styles: () => import('../scss/modules/cta-module.scss')
  },
  {
    name: 'iconCardContainer',
    styles: () => import('../scss/modules/icon-card-container.scss'),
    loader: () => import('./modules/iconCardContainer')
  },
  {
    name: 'introductoryCopyContentRow',
    styles: () => import('../scss/modules/introductory-copy-content-row.scss')
  },
  {
    name: 'imageAndTextContentRow',
    styles: () => import('../scss/modules/image-and-text-content-row.scss')
  },
  {
    name: 'medicineCardsListing',
    styles: () => import('../scss/modules/medicine-cards-listing.scss')
  },
  {
    name: 'footer',
    styles: () => import('../scss/modules/footer.scss')
  },
  {
    name: 'quoteAndImage',
    styles: () => import('../scss/modules/quote-and-image-card.scss')
  },
  {
    name: 'referencesModule',
    styles: () => import('../scss/modules/references-module.scss')
  },
  {
    name: 'locationCardContainer',
    styles: () => import('../scss/modules/location-card-container.scss')
  },
  {
    name: 'header',
    loader: () => import('./modules/header/header')
  },
  {
    name: 'searchMenu',
    loader: () => import('./modules/header/search-menu')
  },
  {
    name: 'locationMenu',
    loader: () => import('./modules/header/location-menu')
  },
  {
    name: 'statsCardContainer',
    styles: () => import('../scss/modules/stats-card-container.scss'),
    loader: () => import('./modules/statCardContainer')
  },
  {
    name: 'relatedTherapiesCarousel',
    loader: () => import('./modules/relatedTherapiesCarousel'),
    styles: () => import('../scss/modules/related-therapies-carousel.scss')
  },
  {
    name: 'fullWidthMediaItem',
    loader: () => import('./modules/fullWidthMediaItem')
  },
  {
    name: 'mediaCarouselCard',
    loader: () => import('./modules/mediaCarouselCard')
  },
  {
    name: 'mediaCarousel',
    loader: () => import('./modules/mediaCarousel'),
    styles: () => import('../scss/modules/media-carousel.scss')
  },
  {
    name: 'textCardContainer',
    styles: () => import('../scss/modules/text-card-container.scss')
  },
  {
    name: 'conditionCardsContainer',
    styles: () => import('../scss/modules/condition-cards-container.scss')
  },
  {
    name: 'factSheetsModule',
    styles: () => import('../scss/modules/fact-sheets-module.scss')
  },
  {
    name: 'relatedPatientStories',
    loader: () => import('./modules/relatedPatientStories'),
    styles: () => import('../scss/modules/related-patient-stories.scss')
  },
  {
    name: 'featuredImageTextRow',
    styles: () => import('../scss/modules/featured-image-text-row.scss')
  },
  {
    name: 'featuredTextRow',
    styles: () => import('../scss/modules/featured-text-row.scss')
  },
  {
    name: 'patientStoriesTabbed',
    loader: () => import('./modules/patientStoriesTabbed'),
    styles: () => import('../scss/modules/patient-stories-tabbed.scss')
  },
  {
    name: 'pagination',
    loader: () => import('./modules/pagination')
  },
  {
    name: 'linkListModule',
    styles: () => import('../scss/modules/link-list-module.scss')
  },
  {
    name: 'featuredArticles',
    styles: () => import('../scss/modules/featured-articles.scss'),
    loader: () => import('./modules/featuredArticles')
  },
  {
    name: 'relatedPatientsCarousel',
    loader: () => import('./modules/relatedPatientsCarousel'),
    styles: () => import('../scss/modules/related-patients-carousel.scss')
  },
  {
    name: 'relatedVideoDetailCarousel',
    loader: () => import('./modules/relatedVideoDetailCarousel'),
    styles: () => import('../scss/modules/related-video-detail-carousel.scss')
  },
  {
    name: 'relatedFactSheetCarousel',
    loader: () => import('./modules/relatedFactSheetCarousel'),
    styles: () => import('../scss/modules/related-fact-sheet-carousel.scss')
  },
  {
    name: 'textCardsCarousel',
    loader: () => import('./modules/textCardsCarousel'),
    styles: () => import('../scss/modules/text-cards-carousel.scss')
  },
  {
    name: 'dualSectionTextCards',
    styles: () => import('../scss/modules/dual-section-text-cards.scss')
  },
  {
    name: 'imageGallery',
    loader: () => import('./modules/imageGallery'),
    styles: () => import('../scss/modules/image-gallery.scss')
  },
  {
    name: 'homepageCarousel',
    loader: () => import('./modules/homepageCarousel')
  },
  {
    name: 'eventListing',
    loader: () => import('./modules/eventListing'),
    styles: () => import('../scss/modules/event-listing.scss')
  },
  {
    name: 'videoAndTextRow',
    loader: () => import('./modules/videoAndTextRow'),
    styles: () => import('../scss/modules/video-and-text-row.scss')
  },
  {
    name: 'innovationListing',
    styles: () => import('../scss/modules/innovation-listing.scss')
  },
  {
    name: 'conditionListingModule',
    styles: () => import('../scss/modules/condition-listing-module.scss')
  },
  {
    name: 'reactPagination',
    styles: () => import('../scss/modules/pagination.scss'),
    loader: () => import('./modules/reactPagination'),
    render: reactModule
  },
  {
    name: 'searchPageResults',
    loader: () => import('./modules/searchPageResults'),
    render: reactModule
  },
  {
    name: 'mediaListingResults',
    loader: () => import('./modules/mediaListingResults'),
    render: reactModule
  },
  {
    name: 'contactUsMasthead',
    loader: () => import('./modules/contactUsMasthead')
  },
  {
    name: 'externalLinksModal',
    loader: () => import('./modules/externalLinksModal'),
    styles: () => import('../scss/modules/external-links-modal.scss')
  }
];

export default [...globModules, ...modules];
